import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
const firebaseConfig = {
    apiKey: "AIzaSyC8HHWP5cP2bdc8dvyXuVrXcYNK0hWyzoM",
    authDomain: "rankersapp-e52cb.firebaseapp.com",
    databaseURL: "https://rankersapp-e52cb-default-rtdb.firebaseio.com",
    projectId: "rankersapp-e52cb",
    storageBucket: "rankersapp-e52cb.firebasestorage.app",
    messagingSenderId: "1024520500827",
    appId: "1:1024520500827:web:ead6dfec0bc26a9bac717e",
    measurementId: "G-HD983CM569"
  };



const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging };